export const tunisianGovernorates = [
  "Ariana",
  "Béja",
  "Ben Arous",
  "Bizerte",
  "Gabès",
  "Gafsa",
  "Jendouba",
  "Kairouan",
  "Kasserine",
  "Kébili",
  "Kef",
  "Mahdia",
  "Manouba",
  "Médenine",
  "Monastir",
  "Nabeul",
  "Sfax",
  "Sidi Bouzid",
  "Siliana",
  "Sousse",
  "Tataouine",
  "Tozeur",
  "Tunis",
  "Zaghouan"
];

// Map of governorates to their major cities
export const governorateCities: Record<string, string[]> = {
  "Ariana": ["Ariana", "Ettadhamen", "Kalâat el-Andalous", "La Soukra", "Mnihla", "Raoued", "Sidi Thabet"],
  "Béja": ["Béja", "Amdoun", "Goubellat", "Medjez el-Bab", "Nefza", "Téboursouk", "Testour", "Thibar"],
  "Ben Arous": ["Ben Arous", "Bou Mhel el-Bassatine", "El Mourouj", "Ezzahra", "Fouchana", "Hammam Chott", "Hammam Lif", "Mégrine", "Mohamedia", "Mornag", "Radès"],
  "Bizerte": ["Bizerte", "El Alia", "Ghar El Melh", "Mateur", "Menzel Bourguiba", "Menzel Jemil", "Ras Jebel", "Sejnane", "Tinja", "Utique"],
  "Gabès": ["Gabès", "El Hamma", "Ghannouch", "Mareth", "Matmata", "Métouia", "Nouvelle Matmata"],
  "Gafsa": ["Gafsa", "El Guettar", "El Ksar", "Mdhilla", "Métlaoui", "Redeyef", "Sened", "Sidi Aïch"],
  "Jendouba": ["Jendouba", "Aïn Draham", "Balta-Bou Aouane", "Bou Salem", "Fernana", "Ghardimaou", "Oued Mliz", "Tabarka"],
  "Kairouan": ["Kairouan", "Alaa", "Bou Hajla", "Chebika", "Haffouz", "Hajeb El Ayoun", "Nasrallah", "Oueslatia", "Sbikha"],
  "Kasserine": ["Kasserine", "Fériana", "Foussana", "Haïdra", "Jedelienne", "Sbeitla", "Sbeïtla", "Thala"],
  "Kébili": ["Kébili", "Douz", "El Golâa", "Souk Lahad"],
  "Kef": ["Kef", "Dahmani", "Jérissa", "Kalâat Khasba", "Kalaat Senan", "Nebeur", "Sakiet Sidi Youssef", "Sers", "Tajerouine"],
  "Mahdia": ["Mahdia", "Bou Merdes", "Chebba", "El Jem", "Essouassi", "Hebira", "Ksour Essef", "Melloulèche", "Ouled Chamekh", "Sidi Alouane"],
  "Manouba": ["Manouba", "Borj El Amri", "Djedeida", "Douar Hicher", "El Battan", "Mornaguia", "Oued Ellil", "Tebourba"],
  "Médenine": ["Médenine", "Ben Gardane", "Beni Khedache", "Djerba - Ajim", "Djerba - Houmt Souk", "Djerba - Midoun", "Zarzis"],
  "Monastir": ["Monastir", "Bekalta", "Bembla", "Beni Hassen", "Jemmal", "Ksar Hellal", "Ksibet el-Médiouni", "Moknine", "Ouerdanine", "Sahline", "Sayada", "Téboulba", "Zéramdine"],
  "Nabeul": ["Nabeul", "Béni Khalled", "Béni Khiar", "Dar Chaâbane", "El Haouaria", "El Mida", "Grombalia", "Hammamet", "Kélibia", "Korba", "Menzel Bouzelfa", "Menzel Temime", "Soliman", "Takelsa"],
  "Sfax": ["Sfax", "Agareb", "Bir Ali Ben Khalifa", "El Hencha", "Graïba", "Jebiniana", "Kerkennah", "Mahres", "Sakiet Eddaïer", "Sakiet Ezzit", "Skhira"],
  "Sidi Bouzid": ["Sidi Bouzid", "Bir El Hafey", "Cebbala Ouled Asker", "Jilma", "Meknassy", "Menzel Bouzaiane", "Mezzouna", "Ouled Haffouz", "Regueb", "Souk Jedid"],
  "Siliana": ["Siliana", "Bargou", "Bou Arada", "El Aroussa", "El Krib", "Gaâfour", "Kesra", "Makthar", "Rouhia", "Sidi Bou Rouis"],
  "Sousse": ["Sousse", "Akouda", "Bouficha", "Enfidha", "Hammam Sousse", "Hergla", "Kalâa Kebira", "Kalâa Seghira", "Kondar", "Msaken", "Sidi Bou Ali", "Sidi El Hani"],
  "Tataouine": ["Tataouine", "Bir Lahmar", "Dehiba", "Ghomrassen", "Remada"],
  "Tozeur": ["Tozeur", "Degache", "Hazoua", "Nefta", "Tamerza"],
  "Tunis": ["Tunis", "Bab El Bhar", "Bab Souika", "Carthage", "Cité El Khadra", "El Kabaria", "El Menzah", "El Omrane", "El Omrane supérieur", "El Ouardia", "Ettahrir", "Ezzouhour", "Hraïria", "Jebel Jelloud", "La Goulette", "La Marsa", "Le Bardo", "Le Kram", "Médina", "Séjoumi", "Sidi El Béchir", "Sidi Hassine"],
  "Zaghouan": ["Zaghouan", "Bir Mcherga", "El Fahs", "Nadhour", "Saouaf", "Zriba"]
};